/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_QuantityInputs */

const en_admin_external_booking_edit_quantity = /** @type {(inputs: Admin_External_Booking_Edit_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantity`)
};

/** @type {(inputs: Admin_External_Booking_Edit_QuantityInputs) => LocalizedString} */
const de_admin_external_booking_edit_quantity = en_admin_external_booking_edit_quantity;

/** @type {(inputs: Admin_External_Booking_Edit_QuantityInputs) => LocalizedString} */
const es_admin_external_booking_edit_quantity = en_admin_external_booking_edit_quantity;

/** @type {(inputs: Admin_External_Booking_Edit_QuantityInputs) => LocalizedString} */
const fr_admin_external_booking_edit_quantity = en_admin_external_booking_edit_quantity;

/** @type {(inputs: Admin_External_Booking_Edit_QuantityInputs) => LocalizedString} */
const it_admin_external_booking_edit_quantity = en_admin_external_booking_edit_quantity;

/** @type {(inputs: Admin_External_Booking_Edit_QuantityInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_quantity = en_admin_external_booking_edit_quantity;

/** @type {(inputs: Admin_External_Booking_Edit_QuantityInputs) => LocalizedString} */
const pl_admin_external_booking_edit_quantity = en_admin_external_booking_edit_quantity;

/** @type {(inputs: Admin_External_Booking_Edit_QuantityInputs) => LocalizedString} */
const hu_admin_external_booking_edit_quantity = en_admin_external_booking_edit_quantity;

/** @type {(inputs: Admin_External_Booking_Edit_QuantityInputs) => LocalizedString} */
const ro_admin_external_booking_edit_quantity = en_admin_external_booking_edit_quantity;

/**
* | output |
* | --- |
* | "Quantity" |
*
* @param {Admin_External_Booking_Edit_QuantityInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_quantity = /** @type {((inputs?: Admin_External_Booking_Edit_QuantityInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_QuantityInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_quantity(inputs)
	if (locale === "de") return de_admin_external_booking_edit_quantity(inputs)
	if (locale === "es") return es_admin_external_booking_edit_quantity(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_quantity(inputs)
	if (locale === "it") return it_admin_external_booking_edit_quantity(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_quantity(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_quantity(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_quantity(inputs)
	return ro_admin_external_booking_edit_quantity(inputs)
});
export { admin_external_booking_edit_quantity as "admin.external_booking_edit.quantity" }